<template>
  <div class="modal">
    <!-- 파일 등록 완료 -->
    <AlertModalV2 v-if="isSuccessModal" @confirm-btn="onClickBtnSuccessModal">
      <template #alertmodal-nontitle> {{ alertText }} </template>
    </AlertModalV2>
    <!-- 현재 재생 멈추는 모달 -->
    <ConfirmYesNoV2
      v-if="isStopAndRecordModal"
      @click-no="onClickStopAndRecordCancel"
      @click-yes="onClickStopAndRecordConfirm"
    >
      <template #confirmmodal-nontitle>
        현재 재생중인 음악을 잠시 멈추고 <br />
        녹음을 시작하시겠습니까?
      </template>
    </ConfirmYesNoV2>

    <!-- 초기화 확인 버튼 -->
    <ConfirmYesNoV2 v-if="isInitVoiceRecorder" @click-no="onClickNoVoiceRecorder" @click-yes="onClickYesVoiceRecorder">
      <template #confirmmodal-nontitle>
        초기화 버튼 클릭 시 <br />
        이미 녹음하신 파일은 삭제됩니다. <br />
        녹음을 시작하시겠습니까?
      </template>
    </ConfirmYesNoV2>
    <!-- Voice Audio -->
    <audio
      ref="voideReocrderAudio"
      id="voideReocrderAudio"
      hidden
      @timeupdate="onTimeUpdate"
      @ended="onAudioEnded"
    ></audio>
    <div class="broadcastfile-modal">
      <!-- broadcastfile-header -->
      <div class="broadcastfile-header">
        <div class="header-wrap">
          <img class="arrow-left-icon cursor" src="/media/images/icon/arrow-left-icon.png" alt="arrow-left-icon.png" />
          <h1 class="header-title">음성 녹음</h1>
        </div>
        <a class="common-close-iconwrap  cursor" tabindex="0" @click="onClickClose">
          <img class="common-close-iconwrap" src="/media/images/icon/close-black-icon.png" alt="close-black-icon.png" />
        </a>
      </div>

      <!-- broadcastfile-contents -->
      <div class="broadcastfile-contents">
        <!-- step에 따른 title 상태 -->
        <h1 class="step-title" v-if="step === 1 || step === 2">음성 녹음을 시작해주세요.</h1>
        <h1 class="step-title" v-if="step === 3">녹음이 완료되었습니다.</h1>

        <!-- Step 1 : 음성녹음 전-->
        <p class="max-onemin" v-if="step === 1 || step === 2">(최대 1분)</p>
        <div class="voice-area" id="voicerecording_progress" v-if="step === 1 || step === 2">
          <template v-if="step === 1">
            <div class="gray-bar" v-for="item in maxlength" :key="item"></div>
          </template>
          <canvas v-if="step === 2" id="audioAnalyser" class="audio_analyser"></canvas>
        </div>
        <div v-if="step === 1" class="playcontrol-wrap">
          <img
            @click="onStartVoiceRecord"
            class="ready-icon"
            src="/media/images/icon/ready-voicerecorder-icon.png"
            alt="ready-voicerecorder-icon.png"
          />
        </div>

        <!-- Step 2 : 음성녹음 중-->
        <div v-if="step === 2" class="playcontrol-wrap">
          <img
            @click="onClickStopVoiceRecord(3)"
            class="ready-icon"
            src="/media/images/icon/play-voice-recrod-icon.png"
            alt="play-voice-recrod-icon.png"
          />
        </div>
        <p v-if="step === 2" class="remain-time">
          {{ getRecorderCount }}
        </p>

        <!-- Step : 음성 미리 듣기 -->
        <div class="voice-area preview" id="voicerecording_progress" v-if="step === 3">
          <!-- Progressbar-->
          <div class="progressbar-wrap">
            <div class="progressbar">
              <div class="dot" :style="{ left: dotPosition + '%' }"></div>
            </div>
          </div>
          <!-- Count -->
          <div class="count-wrap">
            <span class="count-time">{{ getAudioCurrentTime }}</span>
            <span class="count-time">{{ getAudioDuration }}</span>
          </div>
        </div>

        <!-- Preview-wrap -->
        <div class="preview-wrap" v-if="step === 3">
          <div class="preview-circle cursor" @click="onPlayAuido">
            <font-awesome-icon v-if="!isAudoPlay" class="voice-play-icon" :icon="['fas', 'play']" />
            <font-awesome-icon v-else-if="isAudoPlay" class="voice-pause-icon" :icon="['fas', 'stop']" />
          </div>
          <div class="preview-circle cursor" @click="isInitVoiceRecorder = true">
            <img class="retry-icon" src="/media/images/icon/retry-icon.png" alt="retry-icon.png" />
          </div>
        </div>
        <!-- Step : 파일명 입력 -->
        <h1 class="step-title" v-if="step === 4">파일명을 설정해주세요.</h1>
        <div class="inputbox" v-if="step === 4">
          <InputBox
            ref="inputboxWrap"
            :placeholder="'ex) 오프닝 멘트'"
            :value="fileName"
            @change-input="onChangeInput"
          ></InputBox>
        </div>

        <div class="error-wrap" v-if="step === 4 && fileName.length > 10">
          <ErrorMessage :errortext="'파일명은 띄어쓰기 포함 10글자까지만 가능합니다.'" />
        </div>
      </div>

      <div v-if="step === 3 || step === 4" class="broadcastfile-footer">
        <div class="next-btn">
          <BasicButton @click-btn="onClickComplete" :boxsize="'sm'" :disabled="btnDisabled">
            <template #btnname>다음</template>
          </BasicButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicButton from '../BasicButton/BasicButton.vue';
import InputBox from '../InputBox/InputBox.vue';
import ErrorMessage from '../ErrorMessage/ErrorMessage.vue';
import ConfirmYesNoV2 from '../common/ConfirmYesNoV2.vue';
import AlertModalV2 from '../modal/AlertModalV2.vue';
import { registMySoundByFileApi, uploadChosenFileApi } from '@/service/api/mySoundApi';
export default {
  components: {
    BasicButton,
    InputBox,
    ErrorMessage,
    ConfirmYesNoV2,
    AlertModalV2
  },
  emits: ['close-voicerecorder', 'complete-voicerecorder'],
  data() {
    return {
      step: 1,
      maxlength: 50,
      fileName: '',
      isBtnDisabled: false,
      isStopAndRecordModal: false,
      isBackConfirmModal: false,
      audioChuncks: [],
      mp3Blob: null,
      audioRecorder: null,
      audioStream: null,
      file: null,
      audioEle: null,
      audioDuration: 0,
      currentTime: 0,
      fileResult: {
        fileOnServer: null,
        playtime: -1
      },
      recorderCount: 0,
      recorderInterval: -1,
      voiceRecorderIsPlay: false,
      progressBarPercent: 0,
      alertText: null,
      isSuccessModal: false,
      canvasObj: {},
      timeOffset: 70,
      refId: -1,
      now: -1,
      audioContext: null,
      audioContent: null,
      streamSource: null,
      dotPosition: 0, // 진행률(%)으로 사용
      isAudoPlay: false,
      isInitVoiceRecorder: false,
      audioCurrentTime: 0
    };
  },
  mounted() {
    this.canvasObj.bars = [];
  },
  methods: {
    /**
     * @description canvas init
     * @author CHOI DAE GEON
     */
    canvasInit() {
      const voicerecordingProgress = document.querySelector('#voicerecording_progress');
      const width = voicerecordingProgress.clientWidth;
      const height = voicerecordingProgress.clientHeight;

      this.canvasObj.canvas = document.querySelector('#audioAnalyser');
      this.canvasObj.ctx = this.canvasObj.canvas.getContext('2d');
      this.canvasObj.width = width;
      this.canvasObj.height = height;
      this.canvasObj.canvas.width = this.canvasObj.width * window.devicePixelRatio;
      this.canvasObj.canvas.height = this.canvasObj.height * window.devicePixelRatio;
      this.canvasObj.canvas.style.width = this.canvasObj.width + 'px';
      this.canvasObj.canvas.style.height = this.canvasObj.height + 'px';
      const widthDevicePixcelRatio = document.body.clientWidth > 1920 ? 1 : window.devicePixelRatio;
      this.canvasObj.ctx.scale(widthDevicePixcelRatio, window.devicePixelRatio);
    },
    /**
     * @description canvas loop
     * @author CHOI DAE GEON
     */
    canvasLoop() {
      this.canvasObj.ctx.clearRect(0, 0, this.canvasObj.canvas.width, this.canvasObj.canvas.height);
      if (parseInt(performance.now() / this.timeOffset) > this.now) {
        this.now = parseInt(performance.now() / this.timeOffset);

        const freq = Math.floor(Math.random() * 64) + 16;

        this.canvasObj.bars.push({
          x: this.canvasObj.width,
          y: this.canvasObj.height / 2 - freq / 2,
          height: freq,
          width: 2
        });
      }
      this.canvansDraw();
      this.refId = requestAnimationFrame(this.canvasLoop);
    },
    /**
     * @description canvas draw
     * @author CHOI DAE GEON
     */
    canvansDraw() {
      for (let i = 0; i < this.canvasObj.bars.length; i++) {
        const bar = this.canvasObj.bars[i];
        this.canvasObj.ctx.fillStyle = `rgba(255, 45, 85, 1)`;
        this.canvasObj.ctx.fillRect(bar.x, bar.y, bar.width, bar.height);
        bar.x = bar.x - 2;

        if (bar.x < 1) {
          this.canvasObj.bars.splice(i, 1);
        }
      }
    },
    clearCanvas() {
      this.canvasObj.bars = [];
      this.canvasObj.ctx.clearRect(0, 0, this.canvasObj.canvas.width, this.canvasObj.canvas.height);
      this.canvasObj.ctx.beginPath();
      cancelAnimationFrame(this.refId);
      this.now = -1;
    },
    onClickClose() {
      this.$gatag.event('web_broadcast_record_page_back'); // 음성 녹음 페이지 뒤로가기
      this.$emit('close-voicerecorder');
    },
    onChangeInput(val) {
      this.fileName = val;
      if (this.fileName.length > 10) {
        setTimeout(() => {
          this.fileName = val.slice(0, 10);
          this.$refs.inputboxWrap.textSlice();
        }, 800);
      }
    },
    onClickStopAndRecordCancel() {
      this.isStopAndRecordModal = false;
    },
    onClickStopAndRecordConfirm() {
      this.isStopAndRecordModal = false;
      this.$store.dispatch('controlMusic');
      this.onStartVoiceRecord();
    },

    /**
     * @description 목소리 녹음 시작
     * @author CHOI DAE GEON
     */
    onStartVoiceRecord() {
      this.$gatag.event('web_broadcast_record_page_record_start'); // 음성 녹음 시작 버튼
      if (navigator.mediaDevices) {
        if (this.$store.state.isPlay) {
          this.$gatag.event('web_broadcast_record_play_confirm'); // 음성 녹음 재생중 시작 팝업
          this.isStopAndRecordModal = true;
        } else {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then(stream => {
              this.audioStream = stream;
              this.audioRecorder = new MediaRecorder(stream);
              this.audioRecorder.addEventListener('dataavailable', this.onDataAvailable);

              this.audioRecorder.start();

              this.recorderInterval = setInterval(() => {
                if (this.recorderCount < 60) {
                  this.recorderCount += 1;
                } else {
                  this.step = 3;
                  this.audioStream.getTracks().forEach(track => track.stop());
                  console.log(this.recorderCount);

                  this.audioDuration = this.recorderCount;
                  clearInterval(this.recorderInterval);
                }
              }, 1000);
              this.step = 2;
              this.$nextTick(() => {
                this.now = parseInt(performance.now()) / this.timeOffset;
                // canvas init
                this.canvasInit();

                this.canvasObj.ctx.beginPath();

                // canvan loop
                this.canvasLoop();
              });
            })
            .catch(err => {
              console.log('Error accessing the microphone: ' + err);
            });
        }
      }
    },
    async onDataAvailable(event) {
      this.audioChuncks.push(event.data);
      const blob = new Blob(this.audioChuncks, { type: 'application/octet-stream' });
      this.mp3Blob = blob;
      const audioEle = this.$refs.voideReocrderAudio;
      const audioUrl = URL.createObjectURL(blob);

      audioEle.src = audioUrl;
      if (this.step === 2) {
        this.step = 3;
        // try {
        //   const formData = new FormData();
        //   formData.append('userId', this.$cookies.get('userId'));
        //   formData.append('spaceId', this.$cookies.get('spaceId'));
        //   formData.append('fileToUpload', this.mp3Blob);

        //   const { data, status } = await uploadChosenFileApi(formData);
        //   if (status === 200) {
        //     this.audioChuncks = [];
        //     this.step = 3;
        //     const { result } = data;
        //     const { fileOnServer, tempNo } = result;
        //     this.fileResult.fileOnServer = fileOnServer;
        //     this.fileResult.playtime = this.audioDuration;
        //     this.fileResult.tempNo = tempNo;
        //   } else {
        //     throw Error('file upload error');
        //   }
        // } catch (error) {
        //   console.log(error);
        // } finally {
        //   this.isBtnDisabled = false;
        // }
      }
    },
    /**
     * @description 목소리 녹음 중지
     * @author CHOI DAE GEON
     */
    async onClickStopVoiceRecord(step = 3) {
      if (step === 3 && this.recorderCount === 0) return;
      if (this.isBtnDisabled) return;
      this.audioStream.getTracks().forEach(track => track.stop());
      console.log(this.recorderCount);

      this.audioDuration = this.recorderCount;
      clearInterval(this.recorderInterval);
      // this.isBtnDisabled = true;
    },
    async onClickComplete() {
      this.$gatag.event('web_broadcast_record_page_next_button'); // 음성 녹음 다음 버튼
      if (this.isBtnDisabled) return;

      if (this.step === 3) {
        try {
          const formData = new FormData();
          formData.append('userId', this.$cookies.get('userId'));
          formData.append('spaceId', this.$cookies.get('spaceId'));
          formData.append('fileToUpload', this.mp3Blob);

          const { data, status } = await uploadChosenFileApi(formData);
          if (status === 200) {
            this.audioChuncks = [];
            this.step = 4;
            const { result } = data;
            const { fileOnServer, tempNo } = result;
            this.fileResult.fileOnServer = fileOnServer;
            this.fileResult.playtime = this.audioDuration;
            this.fileResult.tempNo = tempNo;
          } else {
            throw Error('file upload error');
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.isBtnDisabled = false;
        }
      } else if (this.step === 4) {
        try {
          this.isBtnDisabled = true;
          const { status } = await registMySoundByFileApi(
            this.$cookies.get('userId'),
            this.$cookies.get('spaceId'),
            this.fileName,
            this.fileResult.tempNo,
            this.fileResult.playtime
          );
          if (status === 200) {
            this.alertText = `파일이 등록되었습니다.`;
            this.isSuccessModal = true;
          }
        } catch (error) {
          console.log(error);
          if (error.response) {
            const { status, data } = error.response;
            if (status === 500) {
              // 업로드 실패시 작성 필요
              this.isSuccessModal = true;
              this.alertText = `파일 등록에 실패하였습니다.`;
            } else if (status === 400) {
              const { resultMsg } = data;
              this.isSuccessModal = true;
              this.alertText = resultMsg;
            }
            this.isSuccessRegistMySound = false;
          }
        } finally {
          this.isBtnDisabled = false;
        }
      }
    },
    onClickBtnSuccessModal() {
      this.isSuccessModal = false;
      this.$emit('complete-voicerecorder');
    },
    /**
     * @description time Update
     */
    onTimeUpdate() {
      const audio = this.$refs.voideReocrderAudio;

      if (audio.duration !== Infinity && !isNaN(audio.duration)) {
        this.dotPosition = (audio.currentTime / audio.duration) * 100;
        this.audioDuration = audio.duration;
      }
      this.audioCurrentTime = this.$refs.voideReocrderAudio.currentTime;
    },
    /**
     * @description audio Play
     */
    onPlayAuido() {
      if (!this.isAudoPlay) {
        this.$refs.voideReocrderAudio.currentTime = 0;
        this.$refs.voideReocrderAudio.play().then(() => {
          console.log('success');
          this.isAudoPlay = true;
        });
      } else {
        this.isAudoPlay = false;
        this.$gatag.event('web_broadcast_record_page_record_stop'); // 음성 녹음 중지 버튼
        this.$refs.voideReocrderAudio.pause();
      }
    },
    /**
     * @description 음원 종료
     */
    onAudioEnded() {
      this.isAudoPlay = false;
    },
    /**
     * @description
     */
    onClickNoVoiceRecorder() {
      this.isInitVoiceRecorder = false;
    },
    /**
     * @description
     */
    onClickYesVoiceRecorder() {
      this.step = 1;
      this.audioChuncks = [];
      this.recorderCount = 0;
      this.clearCanvas();
      this.audioDuration = 0;
      this.dotPosition = 0;
      this.isInitVoiceRecorder = false;
      this.audioCurrentTime = 0;
      this.$refs.voideReocrderAudio.currentTime = 0;
      this.$gatag.event('web_broadcast_record_page_record_stop'); // 음성 녹음 중지 버튼
      this.$refs.voideReocrderAudio.pause();
    }
  },
  computed: {
    btnDisabled() {
      if (this.step === 3) {
        return this.isBtnDisabled;
      } else if (this.step === 4) {
        if (this.fileName && this.fileName.length <= 10) {
          return this.isBtnDisabled;
        }
      }

      return true;
    },
    getRecorderCount() {
      const hh =
        Math.floor(this.recorderCount / 60) > 9
          ? Math.floor(this.recorderCount / 60)
          : `0${Math.floor(this.recorderCount / 60)}`;
      const mm =
        Math.floor(this.recorderCount % 60) > 9
          ? Math.floor(this.recorderCount % 60)
          : `0${Math.floor(this.recorderCount % 60)}`;
      return `${hh}:${mm}`;
    },
    getAudioDuration() {
      const hh =
        Math.floor(this.audioDuration / 60) > 9
          ? Math.floor(this.audioDuration / 60)
          : `0${Math.floor(this.audioDuration / 60)}`;
      const mm =
        Math.floor(this.audioDuration % 60) > 9
          ? Math.floor(this.audioDuration % 60)
          : `0${Math.floor(this.audioDuration % 60)}`;
      return `${hh}:${mm}`;
    },
    getAudioCurrentTime() {
      const hh =
        Math.floor(this.audioCurrentTime / 60) > 9
          ? Math.floor(this.audioCurrentTime / 60)
          : `0${Math.floor(this.audioCurrentTime / 60)}`;
      const mm =
        Math.floor(this.audioCurrentTime % 60) > 9
          ? Math.floor(this.audioCurrentTime % 60)
          : `0${Math.floor(this.audioCurrentTime % 60)}`;
      return `${hh}:${mm}`;
    }
  },
  destroyed() {
    if (this.audioRecorder) {
      this.audioRecorder.removeEventListener('dataavailable', this.onDataAvailable);
    }

    if (this.audioStream) {
      this.audioStream.getTracks().forEach(track => track.stop());
    }
  }
};
</script>
<style scoped src="@/assets/css/broadcastfile/broadcastfile.css"></style>
